import { Component, EventEmitter, OnInit, Output, input, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { Employee } from '@coin/shared/core/util-models';
import { Observable } from 'rxjs';
import { OrganisationService } from '../../../models/organisation-service.model';
import { OrgTreeOverviewItemComponent } from '../org-tree-overview-item/org-tree-overview-item.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'customer-org-tree-overview-items',
  templateUrl: './org-tree-overview-items.component.html',
  styleUrls: ['./org-tree-overview-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [forwardRef(() => OrgTreeOverviewItemComponent), AsyncPipe]
})
export class OrgTreeOverviewItemsComponent implements OnInit {
  readonly rootEmployee = input<Employee>(undefined);
  readonly selectedEmployeeId = input<string>(undefined);
  readonly level = input<number>(undefined);
  readonly lastParent = input(false);
  readonly service = input<OrganisationService>(undefined);
  readonly seasonId = input<string>(undefined);
  readonly openEmployeeInView = input<(payload: { node: Employee; fullTree: boolean }) => unknown>(undefined);
  @Output() itemSelect = new EventEmitter<void>();

  public heads$: Observable<Employee[]>;

  ngOnInit(): void {
    this.loadChildOrganizations();
  }

  private loadChildOrganizations(): void {
    const rootEmployee = this.rootEmployee();
    if (rootEmployee) {
      this.heads$ = this.service().getChildOrganisations(rootEmployee?.orgCode, this.seasonId());
    }
  }
}
